export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SocialApp.vue?vue&type=template&id=af09f520&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SocialApp.vue?vue&type=template&id=af09f520&
// module id = 123
// module chunks = 7